module.exports = __webpack_public_path__ + "img/17-min.9a81e854.jpg";